import React, { FC } from 'react';
import { Seo, useSeoDefaults } from '@funtech-int/yango-shared';
import { Selection } from '@funtech-int/kp-graphql-sdk/yango-movies-www';

import { useI18n } from '@/shared/i18n/seo/useI18n';
import { selectionRoute } from '@/scenarios/selection/routes';

interface SelectionPageHeadProps {
    selection: Selection;
}

export const SelectionPageHead: FC<SelectionPageHeadProps> = ({ selection }) => {
    const intl = useI18n();
    const { seoSiteName } = useSeoDefaults();

    const selectionTitle = selection?.title;

    const title = selectionTitle
        ? intl('selection__seo_title', { title: selectionTitle, brandName: seoSiteName })
        : seoSiteName;

    const description = selectionTitle
        ? intl('selection__meta_description', { title: selectionTitle, brandName: seoSiteName })
        : '-';

    const location = selectionRoute({ id: selection.id });

    return (
        <>
            <Seo.BasicMeta seoTitle={title} seoDescription={description} location={location} />
            <Seo.OgWebsiteMeta ogTitle={title} ogDescription={description} location={location} />
            <Seo.TwitterMeta twitterDescription={description} />
        </>
    );
};
